export default "__VITE_ASSET__DbISflNX__"